import { createContext, useContext } from "react";
import { BaseTheme } from "./themeRoot/config";

interface CezThemeContext {
	baseTheme?: BaseTheme;
}
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const CezThemeContext = createContext<CezThemeContext>(undefined!);

export const useBaseTheme = (): CezThemeContext => {
	return useContext(CezThemeContext);
};
